import { render, staticRenderFns } from "./ViewImgGroup.vue?vue&type=template&id=65fadad3&scoped=true"
import script from "./ViewImgGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./ViewImgGroup.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ViewImgGroup.vue?vue&type=style&index=0&id=65fadad3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fadad3",
  null
  
)

export default component.exports